import { render, staticRenderFns } from "./tsi-footer.vue?vue&type=template&id=2c6bf6e8"
import script from "./tsi-footer.vue?vue&type=script&lang=js"
export * from "./tsi-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports